import React, { useContext, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setSelectedDeviceMine } from "../../redux";
import { ProfileSection } from "../../context/ProfileContext";
import { FiHardDrive } from "react-icons/fi";
import Cookies from "js-cookie";
import { Alert } from "../Alert";
import { DeviceMineContext } from "../../context/DeviceMineContext";
import { useTranslation } from "react-i18next";

const DeviceMine = () => {
  const { t } = useTranslation();
  // const deviceMine = useSelector((state) => state.deviceMine.deviceMine);
  const { deviceMine, setDeviceMine } = useContext(DeviceMineContext);
  const { ProfileShowHideFunc } = useContext(ProfileSection);
  const dispatch = useDispatch();
  const token = Cookies.get("token");
  const [deviceSerial, setDeviceSerial] = useState("");
  const [updateDeviceMine, setUpdateDeviceMine] = useState(deviceMine);
  const [submitAlert, setSubmitAlert] = useState(false);
  const userInfo = useSelector((state) => state.userProfileInfo);

  const deviceInfoPage = (device) => {
    dispatch(setSelectedDeviceMine(device));
    ProfileShowHideFunc("deviceInfo");
  };
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
    request: "",
    question: "",
  });
  const toggleAlert = (x) => {
    setShowAlert(!showAlert);
    if (x) {
      const y = updateDeviceMine.filter((d, i) => {
        return d.serial !== deviceSerial;
      });
      // setUpdateDeviceMine(y);
      setDeviceMine(y);
      console.log(deviceMine);
    }
  };

  const handleDeviceDisjoint = (device) => {
    setDeviceSerial(device.serial);
    setShowAlert((prevState) => ({
      ...prevState,
      show: true,
      message: t("آیا دستگاه ") + t(`${device.caption}`) + t("حذف گردد؟"),
      type: "Warning",
      question: true,
      request: "DeleteDeviceDisjoint",
    }));
  };

  return (
    <>
      <div style={{ height: "70vh", overflow: "auto" }}>
        <div>
          <i className="circleTop icon-plug text-center m-auto"></i>
          <div className="text-center mt-2">
            <p className="m-0">{t("لیست دستگاه ها")}</p>
          </div>
        </div>
        <div className="my-3 p-2">
          {deviceMine?.map((device, index) => {
            return (
              <div
                key={index}
                onClick={() => deviceInfoPage(device)}
                className="mb-3 cursor bg-white p-2 deviceMineList d-flex align-items-center px-2 py-2 position-relative"
              >
                <i
                  className="icon-trash-empty position-absolute"
                  style={{
                    left: "15px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDeviceDisjoint(device);
                  }}
                ></i>
                <span
                  className="d-block bg-white fn23 text-center"
                  style={{ width: "98px" }}
                >
                  {device.category.image !== "MPX4.jpg" ? (
                    <img src={device.category.image} className="w-75" />
                  ) : (
                    <FiHardDrive />
                  )}
                </span>
                <div className="text-right mr-3">
                  <p className="fn mb-1">{device.caption}</p>
                  <p className="fn12 mb-1 text-muted">
                    {device.category.description}
                  </p>
                  {console.log(device)}
                  <p className="fn12 mb-1 text-muted">{t("ویجت")}</p>
                  <p className="fn12 mb-1 text-muted m-0">{device.serial}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="d-flex flex-wrap justify-content-center mt-4">
        <div
          className="mx-3 d-flex justify-content-center align-items-center flex-column text-center"
          onClick={() => ProfileShowHideFunc("firstPage")}
        >
          <span className="profileAddUser bg-white d-block icon-left-1 cursor"></span>
          <small className="fn12 mt-1">{t("بازگشت")}</small>
        </div>
      </div>
      {showAlert.show && (
        <Alert
          message={showAlert.message}
          type={showAlert.type}
          question={showAlert.question}
          request={showAlert.request}
          deviceSerial={deviceSerial}
          toggleAlert={toggleAlert}
          setSubmitAlert={setSubmitAlert}
        />
      )}
    </>
  );
};

export { DeviceMine };
